<template>
  <div class="live">
    <van-notice-bar
      left-icon="volume-o"
      :text="event.announce"
      v-if="(event.announce && !isFullScreen)"
    />
    <div class="header" v-if="!isFullScreen">
      {{ event.name }} <div style="position:fixed; top:5px; right: 15px; color: #eee;">{{ user ? user.id : '' }}</div>
    </div>
    <template v-if="(!live_state.correct || live_state.red_pack)">
    <div :class="'video' + (isFullScreen ? ' video-fullscreen' : '')">
      <div class="player" v-if="event.video" ref="mPlayer">
        <video :src="videoUrl" 
          :poster="coverUrl"
          preload="auto"
          show-progress="false"
          webkit-playsinline="true"
          playsinline="true"
          x5-video-player-type="h5"
          x5-playsinline="" 
          x5-video-player-fullscreen="false"
          auto-pause-if-navigate="true"
          auto-pause-if-open-native="true"
          style="object-fit: contain;"
          disableremoteplayback
          disablepictureinpicture
          x-webkit-airplay="deny"
          @canplay="videoCanPlay"
          @play="videoPlay"
          @pause="videoPause"
          @timeupdate="videoTimeUpdate"
          @ended="videoEnded"
          @seeked="videoSeeked"
          @loadedmetadata="videoMeta"
          controlsList="nodownload nofullscreen noremoteplayback"
          ref="vplayer"
        />
        <div class="controls" v-if="videoUrl && videoReadyPlay && !videoEnd && !videoPlaying" @click="handlePlay">
          <van-icon name="play-circle-o" />
        </div>
        <!--<div class="controls" v-if="videoUrl && videoReadyPlay && videoEnd && !videoPlaying" @click="handleRePlay">
          <van-icon name="play-circle-o" />
        </div>-->
        <div class="controls" v-if="type == 'before_login' || type == 'login'" @click="type = 'login'">
          <van-icon name="play-circle-o" />
        </div>
        <div class="live-state"><van-icon name="play-circle-o" color="red" /> {{ videoCurrentTime }}</div>
        <div class="live-skip_opening"  v-if="videoUrl && videoReadyPlay && canSkipOpening" @click.prevent="handleSkipOpen">
          跳过片头
        </div>
        <div class="live-action_pause"  v-if="videoUrl && videoReadyPlay && videoPlaying" @click.prevent="handlePause">
          暂停播放
        </div>
        <div class="live-fullscreen" v-if="videoUrl && videoReadyPlay && !isFullScreen" @click="(isFullScreen = true)">
          <van-icon name="expand-o" />
        </div>
        <div class="live-exitfullscreen" v-if="videoUrl && videoReadyPlay && isFullScreen" @click="(isFullScreen = false)">
          <van-icon name="cross" />
        </div>
      </div>
    </div>
    <div class="content">
      <div class="event-action">
        <div class="event-like" @click="handleLike">
          <div class="like-icon">
            <van-icon :name="is_like ? 'like' : 'like-o'" />
          </div>
          <div class="like-count">{{ event.like_count ? event.like_count : 0 }}</div>
        </div>
      </div>
      <div class="user-info" v-if="user">
        <div>会员账号：</div>
        <div class="user-icon"><img :src="user.headimgurl" /></div>
        <div class="user-nick"> {{ user.nickname }}</div>
      </div>
      <van-tabs v-model="activeTab" background="#ffffff" color="red" v-if="type == 'event' && !is_guest">
        <van-tab title="回顾" name="question" v-if="has_question">
          <div class="question-list tab-ctx" v-if="!live_state.red_pack">
            <div class="" style="text-align: center" v-if="(live_state.answer > 0)">
              您已经回答 <span style="color: red">{{ live_state.answer }}</span> 次
            </div>
            <div class="question" v-for="q in question" :key="q.id">
              <van-cell>问题：{{ q.question }}</van-cell>
              <van-radio-group v-model="answer[q.id]" style="margin-left: 20px;">
                <van-cell-group>
                  <van-cell
                    v-for="(a,idx) in q.answer"
                    :title="String.fromCharCode(65+idx) + '. ' + a[1]"
                    :key="a[0]" 
                    :clickable="videoComplete" @click="answer[q.id] = a[0]">
                    <template #right-icon >
                      <van-radio :name="a[0]" v-if="videoComplete" checked-color="#ee0a24" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
            <div class="action-redpack--">
              <van-button
                block round
                color="linear-gradient(to right, #ff6034, #ee0a24)"
                @click="submitAnswer"
              >
                <van-icon name="bill" color="#ffffff" /> 提交</van-button>
            </div>
          </div>
          <div 
            class="question-list question-tips" 
            style="background: #ccc; color: #000;min-height: 200px; display: flex; flex-direction:column; text-align: center;justify-content: center; align-content: center;" 
            v-if="live_state.red_pack"
          >
            <p>答题红包已领取</p>
            <p>再接再厉明天再来领红包！</p>
          </div>
        </van-tab>
        <!--
        <van-tab title="直播简介" name="intro">
          <div class="intro tab-ctx" v-html="event.intro">
          </div>
        </van-tab>
        <van-tab title="联系我们" name="contact" v-if="gm_info">
          <p style="padding: 0 5px; text-align: center; font-size: 14px;">您可通过下面的联系方式获取更多信息</p>
          <van-field name="headimgurl" label="微信" input-align="right" :center="true">
            <template #input>
              <img :src="gm_info.headimgurl" class="headicon" style="margin-right: 10px;" /> {{ gm_info.nickname }}
            </template>
          </van-field>
          <van-field label="手机号" input-align="right" :value="gm_info.mobile" readonly />
          <van-field name="friendcode" label="二维码" input-align="right" :center="true" v-if="gm_info.friendcode">
            <template #input>
              <img :src="res_url + 'fc/' + gm_info.friendcode" class="friendcode" />
            </template>
          </van-field>
        </van-tab>
        -->
        <van-tab title="投诉" :to="'/report?state=' + state"></van-tab>
      </van-tabs>
      <!--
      <div class="action-redpack" v-if="type == 'before_login' || type == 'login' || is_guest">
        <van-button block round color="linear-gradient(to right, #ff6034, #ee0a24)" @click="type = 'login'">
          <van-icon name="bill" color="#ffffff" />{{ event.is_open == 0 ? '观看直播领红包' : '登录观看领红包' }}
        </van-button>
      </div>
      -->
    </div>
    </template>
    <template v-else>
    <div class="hb_title">
      <div class="hb_title_icon"></div>
    </div>
    <div class="hb_main">
      <div class="l_text">恭喜·您提交答案全部正确</div>
      <div class="s_text">再接再厉明天再来领红包！</div>
      <div class="hb_open">
        <div class="open-btn" @click="handleOpenHB"></div>
      </div>
    </div>
    </template>
    <van-popup :value="showLogin" :close-on-click-overlay="false" @click-overlay="closeLogin">
      <login-form :state="state" title="绑定手机" tips="根据《网络安防法》实施要求，请绑定您的手机号" @success="onSuccess" @error="onError" />
    </van-popup>
    <van-popup :value="showGMInfo" :close-on-click-overlay="false">
      <div class="gm_error">
        <div class="title">链接错误</div>
        <div class="content">
          <p v-if="gm_message">{{ gm_message  }}</p>
          <p v-else>您访问了错误的直播链接，请与您的群主联系获取直播链接。</p>
          <van-field label="节目编码" input-align="right" :value="state" readonly />
          <template v-if="user">
          <van-field label="会员ID" input-align="right" :value="user.id" readonly />
          <van-field label="会员昵称" input-align="right" :value="user.nickname" readonly />
          </template>
          <template v-if="gm_info">
          <van-field label="群管理员ID" input-align="right" :value="gm_info.id" readonly />
          <van-field name="headimgurl" label="微信" input-align="right" :center="true">
            <template #input>
              <img :src="gm_info.headimgurl" class="headicon" style="margin-right: 10px;" /> {{ gm_info.nickname }}
            </template>
          </van-field>
          <van-field label="手机号" input-align="right" :value="gm_info.mobile" readonly />
          <van-field name="friendcode" label="二维码" input-align="right" :center="true" v-if="gm_info.friendcode">
            <template #input>
              <img :src="res_url + 'fc/' + gm_info.friendcode" class="friendcode" />
            </template>
          </van-field>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  
import LoginForm from '@/components/LoginForm'
import { mapState } from 'vuex'
import { Toast } from 'vant'
import { showLive, showLiveQ, showQuestion, getState, putState, submitAnswer, getRedPack, eventLTK, skipOpen } from '@/api'
import { wxInit } from '@/utils/auth';

import createNEGuardian from  '@/utils/YiDunProtector-Web-2.1.1.js';

const neg = createNEGuardian({ productId: window.__config__.ypid, timeout: 6000 })

try {
  wxInit()
} catch (e) {}
export default {
  name: 'Login',
  components: {
    LoginForm
  },
  data() {
    return {
      activeTab: 'question',
      isFullScreen: false,
      is_like: false,
      is_guest: false,
      is_sync_time: false,
      ltk: undefined,
      type: '',
      share: {
        name: '凯蒙名医直通车',
        desc: '凯蒙名医直通车',
        imgUrl: '',
        link: '',
        success: function () {
          console.log('success')
        },
        cancel: function () {
          console.log('cancel')
        }
      },
      gm_message: undefined,
      gm_info: {
        id: undefined,
        friendcode: undefined,
        nickname: undefined,
        mobile: undefined,
        headimgurl: undefined,
      },
      event: {
        announce: undefined,
        name: '欢迎',
        intro: undefined,
        video: {
          file_key: ""
        }
      },
      live: null,
      live_state: {
        answer: 0,
        correct: false,
        red_pack: false,
      },
      has_question: false,
      question: [],
      answer: {},
      ticket: undefined,
      videoPlaying: false,
      videoReady: false,
      videoReadyPlay: false,
      videoReadyTime: 0,
      videoEnd: false,
      videoComplete: false,

      canSkipOpening: false,

      duration: 0,
      currentTime: 0,

      redPackSended: true,

      lastUpdateSeq: 0,
      lastUpdateTime: 0,
      lastUpdateDate: 0,
      visibleChange: () => {
        if (document.hidden) {
          this.handlePause();
        }
      }
    }
  },
  watch: {
  },
  mounted() {
    document.title = '';
    this.init();
    document.addEventListener('visibilitychange', this.visibleChange)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.visibleChange)
  },
  computed: {
    ...mapState(['user']),
    state() {
      if ('state' in this.$route.query) {
        return this.$route.query.state
      }
      return ''
    },
    t_count() {
      let count = 1;
      if (this.ticket) {
        for (let i = 0; i < this.ticket.length; i++) {
          let code = this.ticket.charCodeAt(i)
          if (code >= 65 && code <= 85) {
            count++
          }
        }
      }
      return count;
    },
    showLogin() {
      return this.type == 'login'
    },
    showGMInfo() {
      return this.type == 'gm_error'
    },
    res_url() {
      return window.__config__.res_url;
    },
    videoUrl() {
      if ('video' in this.event) {
        return window.__config__.video_url + this.event.video.file_key;
      }
      return '';
    },
    coverUrl() {
      if ('cover_img' in this.event && this.event.cover_img) {
        return window.__config__.res_url + this.event.cover_img;
      }
      return ''
    },
    videoDuration() {
      return this.timeText(this.duration)
    },
    videoCurrentTime() {
      return this.timeText(this.currentTime)
    }
  },
  methods: {
    // handleFS() {
    //   if ('mPlayer' in this.$refs) {
    //     this.$refs.mPlayer.requestFullscreen();
    //   }
    // },
    initShare: function () {
      // return;
      wx.ready(() => {
        // wx.onMenuShareTimeline(this.share);
        // wx.onMenuShareAppMessage(this.share);
        // if ('updateTimelineShareData' in wx) {
        //   wx.updateTimelineShareData(this.share)
        // }
        // if ('updateAppMessageShareData' in wx) {
        //   wx.updateAppMessageShareData(this.share);
        // }
        wx.hideAllNonBaseMenuItem();
        // wx.showMenuItems({
        //   menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline']
        // });
      })
    },
    async handleLike() {
      if (!this.ltk) return;
      if (this.is_like) return;

      let resp
      try {
        resp = await eventLTK(this.ltk)
      } catch (e) {}
      this.event.like_count = +this.event.like_count + 1;
      this.is_like = true
    },
    async handleOpenHB() {
      if (![1,101].includes(this.user.member_type)) {
        this.type = 'login';
        return;
      }
      let vm = this;
      let rnd = Math.random();
      if (this.redPackSended || rnd > 0.5) {
        Toast('操作太频繁，请稍后再试')
        return;
      }
      Toast.loading({
        message: '请稍等',
        duration: 0,
      })

      if (wx && wx.miniProgram) {
        let wxa = await (new Promise((resolve, reject) => {
          wx.miniProgram.getEnv(function(res) {
            resolve(res.miniprogram) // true
          })
        }))
        if (wxa) {
          wx.miniProgram.navigateTo({url: '/pages/rp/index?state=' + this.state})
          return;
        }
      }

      let token;

      let resp
      try {
        this.redPackSended = true;
        resp = await getRedPack(this.state, {
          token
        })
      } catch (e) {
        setTimeout(() => {
          this.redPackSended = false;
        }, 2500);
      }
      if (resp) {
        if (resp.data &&
          'need_regist' in resp.data &&
          resp.data.need_regist
        ) {
          this.type = 'login';
          return;
        }
        if (resp.data.success && 
          resp.data.data && 
          resp.data.data.mch_id && 
          resp.data.data.app_id && 
          resp.data.data.package_info
        ) {
          wx.ready(function () {
            wx.checkJsApi({
              jsApiList: ['requestMerchantTransfer'],
              success: function (res) {
                if (res.checkResult['requestMerchantTransfer']) {
                  WeixinJSBridge.invoke('requestMerchantTransfer', {
                      mchId: resp.data.data.mch_id,
                      appId: resp.data.data.app_id,
                      package: resp.data.data.package_info
                    },
                    function (res) {
                      Toast.clear()
                      if (res.err_msg === 'requestMerchantTransfer:ok') {
                        Toast.success('领取成功')
                        // res.err_msg将在页面展示成功后返回应用时返回success，并不代表付款成功
                      } else {
                        Toast.fail(res.err_msg)
                      }
                      setTimeout(async () => {
                        await getRedPack(vm.state)
                        vm.live_state.red_pack = true;
                      }, 3000)
                    }
                  );
                } else {
                  Toast.fail('你的微信版本过低，请更新至最新版本。');
                }
              }
            });
          });
        }
        // Toast.success('领取成功，请留意微信提醒')
      }
    },
    async submitAnswer() {
      if (!this.videoComplete) {
        return Toast.fail('请完整观看直播后再答题')
      }
      for (let i = 0; i < this.question.length; i++) {
        if (!this.answer[this.question[i].id]) {
          return Toast.fail('您还有问题未回答')
        }
      }
      let loading = Toast.loading({
        message: '请稍等',
        duration: 0,
      })
      let resp
      try {
        resp = await submitAnswer(this.state, this.answer)
      } catch (e) {
      }
      if (resp) {
        if (resp.data.pass) {
          Toast.success('恭喜你，答对啦！')
          this.live_state.correct = true;
        } else {
          Toast.fail('很遗憾，没答对，再接再厉哦')
        }
        if ('answer' in resp.data) {
          this.live_state.answer = resp.data.answer;
        }
      } else {
        loading.clear();
      }
    },
    timeText(duration) {
      let text = '';
      let second = duration % 60;
      text = second.toFixed(0).padStart(2, '0') + ''
      duration = (duration - second) / 60;
      
      let minute = duration % 60;
      text = ('' + minute).padStart(2, '0') + ':' + text
      duration = (duration - minute) / 60;
      if (duration > 0) {
        text = duration + ':' + text
      }
      return text;
    },
    async init() {
      const vm = this;
      const user = this.$store.state.user
      if (user && user.member_type > 0) {
        await this.onSuccess()
      } else {
        await this.loadLive()
      }
      // await reportUploadImage()
    },
    async prepareShare(resp) {
      if (this.event) {
        if ('share' in this.event) {
          this.share = this.event.share;
          if (!this.share.title) {
            this.share.title = this.event.name;
          }
          if (!this.share.desc) {
            this.share.desc = this.event.name;
          }
        }
        if ('poster_img' in this.event && this.event.poster_img) {
          this.share.imgUrl = window.__config__.res_url + this.event.poster_img;
        }
        if ('share_link' in resp.data) {
          this.share.link = resp.data.share_link;
        }
        console.log(this.share);
        this.initShare();
      }
    },
    async loadLive(first = true) {
      let loading = Toast.loading({
        message: '请稍等',
        duration: 0,
      })
      let resp
      let share_link
      try {
        if (this.$route.name == 'LiveQ') {
          resp = await showLiveQ(this.state)
        } else {
          resp = await showLive(this.state)
        }
      } catch (e) {
        console.log('live error', e)
      }
      if (resp) loading.clear();
      this.is_guest = false;
      this.gm_message = undefined;
      this.redPackSended = false;
      if (resp.data.is_guest) {
        this.is_guest = true;
        this.event = resp.data.event
        this.gm_info = resp.data.gm_info
        this.prepareShare(resp);
        if (this.event.is_open == 0) {
          if (this.$route.name == 'LiveQ') {
            this.$router.replace('/cover?state=' + this.state)
          } else {  
            this.type = 'login'
          }
          return;
        } else {
          this.type = resp.data.type
        }
      } else {
        this.type = resp.data.type
        this.$nextTick(() => {
          this.activeTab = 'question'
        })
        if ('gm_info' in resp.data) {
          this.gm_info = resp.data.gm_info
        }
        if (this.type == 'gm_error' && 'message' in resp.data) {
          this.gm_message = resp.data.message;
        }
      }

      if (first && this.type == 'event') {
        this.event = resp.data.event
        this.ticket = 'ticket' in resp.data ? resp.data.ticket : '';
        this.is_like = 'is_like' in resp.data ? resp.data.is_like : false;
        this.ltk = 'ltk' in resp.data ? resp.data.ltk : undefined;
        if ( 'question' in resp.data && resp.data.question.length > 0) {
          this.question = resp.data.question;
          this.answer = {}
          this.question.forEach((v) => {
            this.$set(this.answer, v.id, undefined)
          })
          setTimeout(() => {
            this.has_question = true;
            this.$nextTick(() => {
              this.activeTab = 'question'
            })
          }, 5000);
        }
        await this.syncState()
        this.prepareShare(resp);
      }
    },
    async onSuccess() {
      // this.showLogin = false
      if (!this.state) {
        return this.$router.replace('/error')
      }
      await this.loadLive()
    },
    async handleSkipOpen() {
      this.canSkipOpening = false;
      return skipOpen(this.ticket).then((resp) => {
        if (resp.data.time && resp.data.time > this.currentTime) {
          this.videoReadyTime = +resp.data.time
          this.lastUpdateTime = +resp.data.time + (120 + 60 * Math.random())
          this.lastUpdateSeq = +resp.data.seq
          this.$nextTick(() => {
            this.videoShift(resp.data.time)
          })
        }
      })
    },
    async syncState(needUpdateTime = true) {
      if (this.is_guest) {
        this.videoReadyPlay = true
        this.videoComplete = false;
        return;
      }
      let state = await getState(this.ticket)
      if ('answer' in state.data) {
        this.live_state.answer = state.data.answer;
      }
      if ('correct' in state.data) {
        this.live_state.correct = state.data.correct;
      }
      if ('red_pack' in state.data) {
        this.live_state.red_pack = state.data.red_pack;
      }
      if ('skip_open' in state.data) {
        this.canSkipOpening = state.data.skip_open;
      }
      if (('time' in state.data) && needUpdateTime) {
        this.videoReadyPlay = true
        if (!state.data.complete) {
          await (new Promise((resolve, reject) => {
            this.videoReadyTime = +state.data.time
            this.lastUpdateTime = +state.data.time + (120 + 60 * Math.random())
            this.lastUpdateSeq = +state.data.seq
            this.videoComplete = state.data.complete ?? false
            this.$nextTick(() => {
              this.videoShift(state.data.time)
              resolve();
            })
          }))
        } else {
          this.videoComplete = true;
        }
      }
      if ('qk' in state.data) {
        await this.loadQuestion(state.data.qk);
      }
    },
    async loadQuestion(qk) {
      if (this.has_question) return;
      let resp
      try {
        resp = await showQuestion(qk)
      } catch (e) {
        console.log('q error', e)
        return;
      }
      if ('question' in resp.data) {
        this.question = resp.data.question;
        this.answer = {}
        this.question.forEach((v) => {
          this.$set(this.answer, v.id, undefined)
        })
        this.has_question = true;
        this.$nextTick(() => {
          this.activeTab = 'question'
        })
      }
    },
    videoShift(time) {
      this.is_sync_time = true;
      console.log('videoShift', time)
      try {
        let video = this.$refs.vplayer;
        if (video) {
          video.currentTime = time
        }
      } catch (e) {
        console.log('play error', e)
      }
    },
    onError() {
      this.$router.replace('/error')
    },
    closeLogin() {
      if (this.event.is_open == 0) {
        this.type = 'before_login'
      } else {
        this.type = 'event'
      }
    },
    videoMeta(event) {
      this.duration = event.target.duration
    },
    videoPlay(event) {
      this.videoPlaying = true
      // console.log('videoPlay', event)
    },
    videoPause(event) {
      this.videoPlaying = false
      this.updateState(event.target.currentTime)
      // console.log('videoPause', event)
    },
    videoCanPlay(event) {
      // console.log(this.videoReadyTime);
      console.log('videoCanPlay', event)
      if (this.videoReadyPlay) {
        if (!this.videoReady) {
          this.videoReady = true
          this.handlePlay()
        }
      }
    },
    updateState(currentTime) {
      if (this.is_guest) return;
      if (this.live_state.red_pack) return;
      let time = +(new Date())
      // console.log(time, this.lastUpdateTime, this.t_count)
      if (this.currentTime > this.videoReadyTime + 30) {
        this.lastUpdateDate = time + (300 + 60 * Math.random()) * 1000
        this.lastUpdateTime = currentTime + (120 + 60 * Math.random())
        this.lastUpdateSeq += 1
        while (this.lastUpdateSeq % 17 == 0 || this.lastUpdateSeq % 53 == 0) {
          this.lastUpdateSeq += 1
        }
        
        return putState(this.ticket, {
          time: currentTime,
          seq: this.lastUpdateSeq,
          ts: time - time % this.t_count + this.t_count
        }).then((resp) => {
          if (resp.data.complete) this.videoComplete = true
          if ('skip_open' in resp.data && !resp.data.skip_open) this.canSkipOpening = false;
          if ('time' in resp.data && resp.data.time > this.videoReadyTime) this.videoReadyTime = resp.data.time;
          if (!this.has_question) {
            if (this.videoComplete ||
              ('time' in resp.data && resp.data.time > 240)
            ) {
              this.syncState(false)
            }
          }
        })
      }
    },
    videoTimeUpdate(event) {
      // console.log('videoTimeUpdate', event)
      this.currentTime = event.target.currentTime
      let time = +(new Date())
      if ((time - this.lastUpdateDate > 0) && (event.target.currentTime > this.lastUpdateTime)) {
        this.updateState(event.target.currentTime)
      }
    },
    videoEnded(event) {
      // console.log('videoEnded', event)
      this.videoEnd = true
      this.updateState(event.target.currentTime)
    },
    videoSeeked(event) {
      console.log('videoSeeked', this.is_sync_time, event)
      if (!this.is_sync_time) {
        this.handlePause();
      } else {
        this.is_sync_time = false;
      }
    },
    // async handleRePlay() {
    //   await this.videoShift(0);
    //   await this.handlePlay();
    // },
    async handlePlay() {
      await this.syncState();
      if (this.user.member_type == 0) {
        await this.loadLive(false);
        if (this.type == 'gm_error') return;
      }
      try {
        let video = this.$refs.vplayer;
        if (video) {
          video.play()
          if (this.canSkipOpening) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.canSkipOpening = false
              }, 5000)
            })
          }
        }
      } catch (e) {
        console.log('play error', e)
      }
    },
    handlePause() {
      try {
        let video = this.$refs.vplayer;
        if (video) {
          video.pause()
          this.updateState(video.currentTime)
        }
      } catch (e) {
        console.log('play error', e)
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.live {
  width: 100%;
  .header {
    height: 60px;
    padding: 10px;
    line-height: 40px;
    overflow: hidden;
    word-break: keep-all;
    text-align: center;
    background: #fff;
  }
  .video {
    width: 100%;
    height: 57vw;
    background: #fff top center;
    background-size: cover;

    &.video-fullscreen {
      // position: absolute;
      position: fixed;
      position: sticky;
      position: -webkit-sticky;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
      background: #000;
      z-index: 999;
    }
    .player {
      position: relative;
      width: 100%;
      height: 100%;
      video {
        width: 100%;
        height: 100%;
        &::-webkit-media-controls {
          display: none;
        }
        &::-webkit-media-controls-timeline {
          display: none;
        }
      }
      .controls {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 60px;
        height: 60px;
        transform: translate(-30px, -30px);
        font-size: 60px;
        color: #fff;
        text-shadow: 3px 3px 5px #999;
      }
      .live-state {
        position: absolute;
        bottom: 0px;
        left: 0px;
        padding: 5px 10px;
        font-size: 12px;
        color: #fff;
        display: inline-block;
        background: rgba(0, 0, 0, 0.5);
      }
      .live-skip_opening {
        position: absolute;
        top: 20px;
        right: 0px;
        padding: 10px 10px;
        font-size: 18px;
        color: #fff;
        display: inline-block;
        background: rgba(0, 0, 0, 0.5);
      }
      .live-action_pause {
        position: absolute;
        bottom: 60px;
        right: 0px;
        padding: 10px 10px;
        font-size: 18px;
        color: #fff;
        display: inline-block;
        background: rgba(0, 0, 0, 0.5);
      }
      .live-fullscreen {
        position: absolute;
        bottom: 0px;
        right: 0px;
        padding: 10px 10px;
        font-size: 18px;
        color: #fff;
        display: inline-block;
        background: rgba(0, 0, 0, 0.5);
      }
      .live-exitfullscreen {
        position: absolute;
        top: 0px;
        right: 0px;
        padding: 12px 12px;
        font-size: 18px;
        border-radius: 6px;
        color: #fff;
        display: inline-block;
        background: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .content {
    margin-top: 10px;
    background: #ffffff;
    
    .event-action {
      font-size: 20px;
      padding: 6px;
      border-bottom: 1px solid #eee;
      display: flex;
      justify-content: flex-end;
      .event-like {
        color: rgb(255, 58, 58);
        display: flex;
        .like-icon {
          margin-right: 5px;
        }
      }
    }

    .user-info {
      padding: 12px 10px 5px 10px;
      margin-top: -2px;
      margin-bottom: 6px;
      width: 100%;
      box-shadow: 0 10px 20px rgb(33 39 65 / 8%);
      display: flex;
      align-items: center;
      .user-icon {
        flex: 0 0 32px;
        width: 32px;
        height: 32px;
        border-radius: 16px;
        overflow: hidden;
        margin: 0 12px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .user-nick {
        flex: 1 1 auto;
        word-break: break-all;
        display: -webkit-box;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }
    }
    .tab-ctx {
      padding: 10px;
      p {
        margin: 6px 0;
      }
      &.question-list {
        padding-bottom: 90px;
      }
    }
  }
}
.gm_error {
  width: 90vw;
  padding: 6px 12px;

  .title {
    font-size: 18px;
    padding: 6px 0 12px;
    border-bottom: 1px solid #999;
    margin-bottom: 6px;
    text-align: center;
  }

  .content {
    padding: 6px 0;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}
.headicon {
  width: 50px;
  height: 50px;
  border-radius: 25px;
}
.action-redpack {
  position: fixed;
  bottom: 30px;
  left: 50%;
  width: 80vw;
  transform: translateX(-40vw);
  font-size: 32px;
}
.action-redpack-- {
  margin: 30px auto 10px auto;
  width: 80vw;
}
.friendcode {
  width: 60vw;
  img {
    width: 100%;
    height: auto;
  }
}
.hb_title {
  width: 100vw;
  height: 23.8vw;
  background: url(../assets/hongbao/cd.png) top center no-repeat;
  background-size: contain;
  display: flex;
  justify-content: center;
  .hb_title_icon {
    width: 22vw;
    height: 22vw;
    background: url(../assets/hongbao/ok.png) center center no-repeat;
  }
}
.hb_main {
  font-family: '楷体',Georgia, 'Times New Roman', Times, serif;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  .l_text {
    font-size: 24px;
    line-height: 2em;
    color: #333;
  }
  .s_text {
    font-size: 18px;
    line-height: 1.8em;
    color: #666;
  }
  .hb_open {
    position: relative;
    margin-top: 20px;
    width: 80vw;
    height: 95vw;
    background: url(../assets/hongbao/hb_bg.png) center center no-repeat;
    background-size: contain;
    .open-btn {
      position: absolute;
      top: 48vw;
      left: 24vw;
      width: 32vw;
      height: 32vw;
      background: url(../assets/hongbao/open.png) center center no-repeat;
      background-size: contain;
    }
  }
}
</style>
<style lang="scss">
.intro {
  img {
    width: 100%;
    height: auto;
  }
}
</style>